"use client";

import React from "react";
import { CircleCheck } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const listItems = ["Doctor of Physical Therapy (DPT)", "Certified Specialized Massage Therapist", "Expertise in mobility and senior comfort"];
export default function AboutMe() {
  const {
    ref: contentRef,
    isVisible: isContentVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: imageRef,
    isVisible: isImageVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="227790" id="biography" className="bg-background text-foreground py-16 md:py-24 overflow-hidden">
      <div className="container mx-auto px-4 md:px-8 max-w-7xl">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-y-12 lg:gap-x-16 items-center">
          
          {}
          <div ref={contentRef} className={`flex flex-col transition-all duration-1000 ease-out ${isContentVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-8"}`}>
            <span className="text-primary text-sm font-medium uppercase tracking-widest mb-4 block">
              Meet Jessica Gade
            </span>
            <h2 className="text-foreground text-4xl md:text-5xl font-bold font-default mb-6 leading-tight">
              Clinical expertise meets a passion for canine wellness.
            </h2>
            <p className="text-foreground/80 text-base md:text-lg mb-8 leading-relaxed font-default">As a Doctor of Physical Therapy and Certified Specialized Massage Therapist, I bridge the gap between veterinary care and daily wellness. My approach focuses on mobility support and recovery, ensuring your companion stays active and comfortable in Durango.</p>

            <ul className="flex flex-col gap-y-4 mb-10">
              {listItems.map((item, i) => <li key={i} data-index={i} className="flex items-start gap-3">
                  <CircleCheck className="text-primary shrink-0 size-6 mt-0.5" />
                  <span className="text-foreground text-base font-medium font-default">
                    {item}
                  </span>
                </li>)}
            </ul>

            <div className="bg-accent text-accent-foreground p-6 md:p-8 rounded-none shadow-sm border-l-4 border-primary">
              <p className="text-lg leading-relaxed font-default italic">
                "My mission is to provide professional, trail-tested bodywork that enhances the bond between you and your dog through improved comfort and movement."
              </p>
            </div>
          </div>

          {}
          <div ref={imageRef} className={`relative w-full transition-all duration-1000 delay-200 ease-out ${isImageVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-8"}`}>
            <div className="relative w-full aspect-[4/5] md:aspect-square rounded-none overflow-hidden shadow-lg">
              <img src="https://durangodogmassage.com/wp-content/uploads/2026/04/image_ax40rcfc.jpg" alt="Jessica Gade, DPT, CSMT - Durango Dog Massage" className="object-cover w-full h-full" loading="lazy" />
              {}
              <div className="absolute inset-0 bg-primary/10 mix-blend-overlay"></div>
            </div>
          </div>

        </div>
      </div>
    </section>;
}